import { reactive } from 'vue'

const state = reactive({
    isLoggedIn: false
});

export default state;